import React, { useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { SvgIcon, InvoicePopup } from 'src/components/common';
import { ApplicationState } from 'src/store';
import { InvoiceTitleType } from 'src/utils/staticData';
import { Button, Modal } from 'zarm-v3';
import './index.scss';

interface InvoiceFormProps {
  isSupportClaims?: boolean;
  /** 用户确认发票信息弹窗是否显示 */
  invoiceConfirmVisible?: boolean;
  /** 用户选择立即支付 */
  toPay?: () => void;
  invoiceOnChange?: (value: any) => void;
  /** 处理发票弹窗的展示和关闭 */
  toggleInvoiceConfirmVisible?: (value: boolean) => void;
}

const InvoiceForm = (props: InvoiceFormProps) => {  
  const { shoppingCart }: any = useSelector((state: ApplicationState) =>
    ({
      shoppingCart: state.prescription.shoppingCart,
    })
  , shallowEqual);

  const mountContainer = useRef(null);

  /** 发票模版编辑弹窗是否显示 */
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const { isSupportClaims = false, invoiceConfirmVisible = false, toPay, invoiceOnChange, toggleInvoiceConfirmVisible } = props;
  
  /**
   * @description 用户点击立即开票，打开发票模版编辑弹窗
   */
  const toCheckInvoice = () => {
    setIsPopupVisible(true);
    toggleInvoiceConfirmVisible?.(false);
  };

  const onEditSuccess = (value) => {
    console.log('value',value);
    invoiceOnChange && invoiceOnChange(value);
    setIsPopupVisible(false);
  };

  const onEditClose = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className='invoice-form' ref={mountContainer}>
      {shoppingCart.invoiceTitleType ? (
        <div className='cell cell-ticket'>
          <div className='label'>发票</div>
          <div className='cell-value' onClick={toCheckInvoice}>
            电子普通({shoppingCart.invoiceTitleType === InvoiceTitleType.PERSONAL ? '个人' : '单位'})
            <SvgIcon className='icon-arrow' src={require('src/svgs/sprite-icon_arrow.svg')} />
          </div>
        </div>
      ) : (
        <div className='cell cell-ticket'>
          <div className='label'>发票</div>
          {isSupportClaims ? (
            <p className='goto-ticket ticket-tips'>购药可享受理赔，不支持个人申请发票</p>
          ) : (
            <div className='goto-ticket' onClick={toCheckInvoice}>
              未开具发票
              <SvgIcon className='icon-arrow' src={require('src/svgs/sprite-icon_arrow.svg')} />
            </div>
          )}
        </div>
      )}
      <InvoicePopup onSuccess={onEditSuccess} visible={isPopupVisible} onClose={onEditClose} />
      <Modal
        mountContainer={mountContainer.current}
        visible={invoiceConfirmVisible}
        animationType='zoom'
        title={<p className='invoice-confirm-modal__title'>您尚未申请开票，是否直接下单购买？</p>}
        onClose={() => {
          toggleInvoiceConfirmVisible?.(false);
        }}
        closable={true}
        maskClosable={true}
        className='invoice-confirm-modal'
        width='75%'
        footer={
          <div className='btn-group'>
            <Button onClick={toCheckInvoice} shape='rect' block>立即开票</Button>
            <Button onClick={toPay} shape='rect' theme='primary' block>直接购药</Button>
          </div>
        }
      >
        <div className='invoice-confirm-modal__content'>
          <p>如您需要报销，请在下单前申请开票或者收货后联系客服申请。</p>
        </div>
      </Modal>
    </div>
  );
};
export default InvoiceForm;
